import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "mobile-search-toggle",
  class MobileSearchToggle extends WYATTElement {
    constructor() {
      super({
        toggleButtonSelector: "[data-mobile-search-toggle]",
        searchIconSelector: ".mobile-search-toggle__search-icon",
        closeIconSelector: ".mobile-search-toggle__close-icon",
      });

      this.bindEvents();
      this.updateToggleState();
    }

    get toggleButton() {
      return document.querySelector(this.config.toggleButtonSelector);
    }

    get searchIcon() {
      return this.toggleButton?.querySelector(this.config.searchIconSelector);
    }

    get closeIcon() {
      return this.toggleButton?.querySelector(this.config.closeIconSelector);
    }

    get isFormVisible() {
      return this.classList.contains("page-header__mobile-search-toggle--open");
    }

    bindEvents() {
      document.addEventListener("DOMContentLoaded", () => {
        this.updateToggleState();
      });

      const observer = new MutationObserver(() => {
        this.updateToggleState();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    updateToggleState() {
      if (!this.searchIcon || !this.closeIcon || !this.toggleButton) return;

      this.searchIcon.classList.toggle("hidden", this.isFormVisible);
      this.closeIcon.classList.toggle("hidden", !this.isFormVisible);

      const { toggleLabel } = this.toggleButton.dataset;
      this.toggleButton.setAttribute("aria-label", toggleLabel);
      this.toggleButton.setAttribute(
        "aria-expanded",
        this.isFormVisible.toString(),
      );
    }
  },
);
